export const questions = {
  sports: [
    {
      question: "How does Schoolify reduce green emissions?",
      options: [
        "Entirely vegan Staff",
        "Planting a tree for every user",
        "Reducing paper communication",
        "Recycling websites",
      ],
      correctOption: "Reducing paper communication",
    },
    {
      question: "What is the main feature of Schoolify?",
      options: [
        "Creating online classrooms",
        "Documenting conversations and progress of students",
        "Online exams",
        "Local school reviews",
      ],
      correctOption: "Documenting conversations and progress of students",
    },
    {
      question: "What amount of money is spent by schools on paper alone?",
      options: ["£20-40K", "£30-50k", "£15-30K", "£4.50"],
      correctOption: "£30-50k",
    },
    {
      question: "Which one of these isn't a Schoolify certificate?",
      options: [
        "Well Done",
        "Brilliant Behaviour",
        "Excellent Achievement",
        "Dazzling Detention",
      ],
      correctOption: "Dazzling Detention",
    },
    {
      question: "How do parents and teachers communicate using Schoolify?",
      options: [
        "By owl",
        "Email",
        "Instant messaging via incident reports",
        "Smoke signals",
      ],
      correctOption: "Instant messaging via incident reports",
    },
    {
      question: "Who did we shout out during our presentation?",
      options: ["Parents", "Teachers", "Both", "Vin Diesel"],
      correctOption: "Teacher",
    },
    {
      question: "What happens when a user views all certificates?",
      options: ["Confetti", "Air horns", "A countdown", "Flashing lights"],
      correctOption: "Confetti",
    },
    {
      question:
        "What action follows the acception or rejection of an absence request ",
      options: [
        "Modal asking if you are sure",
        "Immediate response",
        "404 error",
        "Page refresh",
      ],
      correctOption: "6",
    },
    {
      question: "What was the CSS framework we used for Schoolify?",
      options: ["Bulma", "Bootstrap", "MUI", "Materialize"],
      correctOption: "MUI",
    },
    {
      question: "What isn't a future development for Schoolify?",
      options: [
        "Online shop",
        "Homework/Activity sheets",
        "Consent forms",
        "Substitute teacher hire",
      ],
      correctOption: "Substitute teacher hire",
    },
  ],
};
